import React from 'react'

export const Footer = () => {
  return (
    <footer className='container'>
        <div className='flex flex-y-center'>
        <img alt="" src='/images/logo_2022.png' className='symbol' />
        <div>
            <p>
                    © {new Date().getFullYear()} Ambergris Caye Tours. All rights reserved.
            </p>
            <div className="flex" style={{"--gap":"10px"}}>
                    <a href="/">Privacy Policy</a>
            </div>
        </div>
        </div>
    </footer>
  )
}
